import React from 'react';
import { Card } from './Card';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string | number;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  trend,
  trendValue,
  icon,
  onClick,
  className = ''
}) => {
  return <Card isClickable={!!onClick} onClick={onClick} className={`flex flex-col ${className}`} data-id="element-201">
      <div className="flex justify-between items-start mb-2" data-id="element-202">
        <h3 className="text-sm font-medium text-text-secondary" data-id="element-203">{title}</h3>
        {icon && <div className="text-text-tertiary" data-id="element-204">{icon}</div>}
      </div>
      <div className="flex items-baseline gap-2 mt-1" data-id="element-205">
        <span className="text-2xl font-bold text-text-primary" data-id="element-206">{value}</span>
        {trend && trendValue && <span className={`flex items-center text-xs font-medium ${trend === 'up' ? 'text-status-success' : trend === 'down' ? 'text-status-error' : 'text-text-secondary'}`} data-id="element-207">
            {trend === 'up' && <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-208" />}
            {trend === 'down' && <TrendingDownIcon className="w-3 h-3 mr-1" data-id="element-209" />}
            {trend === 'neutral' && <MinusIcon className="w-3 h-3 mr-1" data-id="element-210" />}
            {trendValue}
          </span>}
      </div>
    </Card>;
};